import { render, staticRenderFns } from "./TaxonomyKeyword.vue?vue&type=template&id=4ee3b919&"
import script from "./TaxonomyKeyword.vue?vue&type=script&lang=js&"
export * from "./TaxonomyKeyword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports